import { render, staticRenderFns } from "./SFormProductPurchaseComp.vue?vue&type=template&id=feee7b16&"
import script from "./SFormProductPurchaseComp.vue?vue&type=script&lang=js&"
export * from "./SFormProductPurchaseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports